// import NAV from "../../utils/nav.const";

const NAV = {
  SIGNUP: "account-aanmaken",
  SIGNIN: "inloggen",
  SIGNOUT: "uitloggen",
  STYLEGUIDE: "styleguide",
  VERIFY_ACCOUNT: "verify-account",
  PROPERTY_OVERVIEW: "zoeken",
  HOME: "home",
  PROPERTY_DETAILS: "te-huur",
  CREATE_TENANT_ACCOUNT: "create-account",
  ACCOUNT_CONFIRMATION: "account-confirmation",
  TENANT_CHECK: "screening",
  FORGOT_PASSWORD: "wachtwoord-vergeten",
  PAYMENT_CONFIRMATION: "premium-tenant-activated",
  PREMIUM_UPGRADE: "upgrade-to-premium",
  FORGOT_PASSWORD_CONFIRMATION: "forgot-password-confirmation",
  RESET_PASSWORD: "reset-password",
  NO_MATCH: "no-match",
  PROFILE: "account",
  PROFILE_OVERVIEW: "profile",
  SCREENING_PROFILE: "screening-profile",
  APPLICATIONS: "applications",
  COMPLEX: "complex",
  COMPLEX_TYPE: "type",
};

export default NAV;
